import { useState } from "react";
import { accountService } from "@miplatform/api";
import { HTTP_STATUSES } from "@miplatform/constants";
import { useComponentState } from "@miplatform/hooks";
import { createUUID } from "@miplatform/utils";

export const useAccountDetailsViewModel = () => {
  const [accountDetail, setAccountDetail] = useState({});

  const stateManager = useComponentState();
  const GET_ACCOUNT_DETAILS_UUID = createUUID();

  const getAccountDetails = (id) => {
    stateManager.abort(GET_ACCOUNT_DETAILS_UUID);
    stateManager.run(async () => {
      const response = await accountService.accounts.getAccountById({ id });
      if (response.status === HTTP_STATUSES.OK) {
        setAccountDetail(response.data);
      }
    }, GET_ACCOUNT_DETAILS_UUID);
  };

  return {
    isLoading: stateManager.isBusy(),
    stateManager,
    accountDetail,
    setAccountDetail,
    getAccountDetails,
  };
};
